"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategyNodeChanges = void 0;
const react_1 = require("react");
const use_history_changes_hook_1 = require("./use-history-changes.hook");
const product_tree_nodes_1 = require("../client/product-tree-nodes");
const useStrategyNodeChanges = () => {
    const { catalogChanges } = (0, use_history_changes_hook_1.useHistoryChanges)();
    const uniqueStrategyNodePaths = (0, react_1.useMemo)(() => {
        const uniquePaths = new Set();
        catalogChanges === null || catalogChanges === void 0 ? void 0 : catalogChanges.forEach(({ path }) => (0, product_tree_nodes_1.addPathRecursive)(path, uniquePaths));
        return uniquePaths;
    }, [catalogChanges]);
    const checkIsNodeChanged = (0, react_1.useCallback)((path) => uniqueStrategyNodePaths.has(path), [uniqueStrategyNodePaths]);
    return {
        checkIsNodeChanged,
    };
};
exports.useStrategyNodeChanges = useStrategyNodeChanges;
